module.exports = __webpack_public_path__ + "static/img/bg-es.b286f5c6.png";